import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'
import { PlantStressSettingsModal } from './PlantStressSettingsModal'

type PlantStressSettingsLinksProps = {
  crop: string
  defaultMaxLowStress: number
  defaultMinHighStress: number
  handleAfterSave: (
    selectedTreeDendrometerStation: string,
    maxLowStress: number,
    minHighStress: number,
  ) => void
}

export const PlantStressTitleLink = ({
  crop,
  defaultMaxLowStress,
  defaultMinHighStress,
  handleAfterSave,
}: PlantStressSettingsLinksProps) => {
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  if (!selectedPropertyHasPermission({ permission: 'EDIT_TREE_DENDROMETER_SETTINGS' })) {
    return titleLink
  }

  titleLink.push(
    <>
      <ResponsiveMenuItem
        key="plant-stress-menu-item"
        data-role="menu-item"
        onClick={() => {
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              plantStressSettingsOpened: true,
            }
          })
        }}
      >
        {translate.phrases.banyanApp('Edit Settings')}
      </ResponsiveMenuItem>
      <PlantStressSettingsModal
        key="plant-stress-modal"
        data-role="modal"
        crop={crop}
        defaultMaxLowStress={defaultMaxLowStress}
        defaultMinHighStress={defaultMinHighStress}
        handleAfterSave={handleAfterSave}
      />
    </>,
  )

  return titleLink
}
